/* eslint-disable indent,linebreak-style */
const TABLE_LIMIT = 50;
const tempLevel = true;
const PROJECT_NAME = 'EZUPP_CRM_DEMO:';

//const tempLevel =  !(!process.env.NODE_ENV || process.env.NODE_ENV === 'development');
const tempDate = new Date();

/**
 * Admin panel SSE — lead events (`NEW_LEAD_CREATED`, `NEW_LEAD_ASSIGNED`, `LEAD_STATUS_UPDATE`).
 * Set to true to subscribe and react; keep false to reduce noise until backend emits again.
 * Pair with backend `SSE_ENABLE_NEW_LEAD_EVENTS` / `SSE_ENABLE_LEAD_STATUS_UPDATE`.
 */
const SSE_ADMIN_NEW_LEAD_EVENTS_ENABLED = false;
const SSE_ADMIN_LEAD_STATUS_UPDATE_ENABLED = false;

export default {
  TIME_ZONE: -(tempDate.getTimezoneOffset() / 60),
  DEFAULT_TIME_FORMAT: "DD-MM-YYYY, HH:mm",
  APP_NAME: "Ezupp-Panel",
  DEFAULT_APP_URL: process.env.REACT_APP_API_URL,
  /** Base URL of whatsapp-api-flow (no trailing slash). Panel WhatsApp chat + templates call this directly. */
  WHATSAPP_FLOW_URL: (process.env.REACT_APP_WHATSAPP_FLOW_URL || "").trim().replace(/\/$/, ""),
  /** Same bearer token as whatsapp-api-flow expects (optional in dev). */
  WHATSAPP_FLOW_TOKEN: (process.env.REACT_APP_WHATSAPP_FLOW_API_TOKEN || "").trim(),
  DEFAULT_DOCTOR_URL: process.env.REACT_APP_DOCTOR_API_URL,
  DOCTOR_MOREPEN_URL: process.env.REACT_APP_APP_API_URL,
  DOCTOR_APP_API_URL: process.env.REACT_APP_DOCTOR_API_URL,
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL,
  // DEFAULT_APP_URL: 'http://35.154.147.169:5055/api/',
  DEFAULT_PAGE_VALUE: TABLE_LIMIT,
  PAGE_VALUE: 10,
  GOOGLE_LOGIN_KEY:
    "1027293586426-qg6lv2vsp57m05tn32m9stku2ljsd1uh.apps.googleusercontent.com",
  GOOGLE_AUTH_KEY:
    "134723802544-4hdevmlr48jv94psl5unmjlpr5m5b1gt.apps.googleusercontent.com",
  // GOOGLE_MAP_KEY: 'AIzaSyDUTIV7DaCvMUMg3qElE-sxdj4zR-dxhFM',
  GOOGLE_MAP_KEY: "AIzaSyA4ZFw4yS0nJW-dOcViHfuQhyUWhgkzUUE",
  FACEBOOK_LOGIN_KEY: "213504989180156",
  DATATABLE_PROPERTIES: {
    title: "Search",
    height: "auto",
    selectable: false,
    showRowHover: true,
    columns: [],
    data: [],
    count: 0,
    page: 0,
    showCheckboxes: false,
    // showHeaderToolbar: true,
    rowsPerPage: TABLE_LIMIT,
    rowsPerPageOptions: [],
  },
  MAP_CENTER: { lat: 28.7383, lng: 77.0822 },
  PRODUCT_TAGS: ["VEG", "VEGAN", "GLUTEN FREE", "DIARY"],
  CURRENCY: "RS.",
  GENERAL_STATUS: {
    PENDING: "PENDING",
    WAITING: "WAITING",
    ACCEPTED: "ACCEPTED",
    ACTIVE: "ACTIVE",
    SUSPENDED: "SUSPENDED",
    ALLOTTED: "ALLOTTED",
    COMPLETED: "COMPLETED",
  },
  STATUS: {
    PENDING: "warning",
    WAITING: "waiting",
    ACCEPTED: "success",
    ACTIVE: "success",
    SUSPENDED: "error",
    ALLOTTED: "success",
    COMPLETED: "success",
  },
  ORDER_STATUS: {
    PENDING: "PENDING",
    ASSIGNED: "ASSIGNED",
    PAYMENT: "PAYMENT",
    ON_PICKUP_LOCATION: "ON_PICKUP_LOCATION",
    OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
    ON_DROP_LOCATION: "ON_DROP_LOCATION",
    DELIVERED: "DELIVERED",
    REJECTED: "REJECTED",
    ACCEPTED: "ACCEPTED",
  },
  ORDER_STATUS_TEXT: {
    ORDER: "Ordered",
    PENDING: "Pending",
    ASSIGNED: "Driver Assigned",
    PAYMENT: "Payment Pending",
    ON_PICKUP_LOCATION: "Dispatching",
    OUT_FOR_DELIVERY: "Out For Delivery",
    ON_DROP_LOCATION: "Arrived On Location",
    DELIVERED: "Order Delivered",
    REJECTED: "Rejected",
    ACCEPTED: "Accepted",
  },
  SOCKET_EVENT: {
    EMIT_TEXT_MESSAGE: PROJECT_NAME + "EMIT_TEXT_MESSAGE",
    SUBSCRIBE: "subscribe",
    UNSUBSCRIBE: "unsubscribe",
    SEND_ROOM_MESSAGE_UPDATE: PROJECT_NAME + "SEND_ROOM_MESSAGE_UPDATE",
    UPDATE_MESSAGE_LIST: PROJECT_NAME + "UPDATE_MESSAGE_LIST",
    UPDATE_JOB_DATA: PROJECT_NAME + "UPDATE_JOB_DATA",
    DISABLE_ROOM_MESSAGE_UPDATE: PROJECT_NAME + "DISABLE_ROOM_MESSAGE_UPDATE",
    ENABLE_ROOM_MESSAGE_UPDATE: PROJECT_NAME + "ENABLE_ROOM_MESSAGE_UPDATE",
    INDIVIDUAL_MESSAGE_CHANNEL: PROJECT_NAME + "INDIVIDUAL_MESSAGE_CHANNEL",
    CONVERSATION_UPDATE: PROJECT_NAME + 'CONVERSATION_UPDATE'
  },
  SOCKET_CHANNELS: {
    NEW_MESSAGE: PROJECT_NAME + "NEW_MESSAGE",
    NEW_CONVERSATION: PROJECT_NAME + "NEW_CONVERSATION",
    CONVERSATION_DELETE: PROJECT_NAME + "CONVERSATION_DELETE",
    INDIVIDUAL_MESSAGE_CHANNEL: PROJECT_NAME + "INDIVIDUAL_MESSAGE_CHANNEL",
    CONVERSATION_UPDATE: PROJECT_NAME + "CONVERSATION_UPDATE",
  },
  SOCKET_EVENTS: {
    NEW_ORDER: "COMPANY_NEW_ORDER",
    ORDER_UPDATE: "COMPANY_ORDER_UPDATE",
    ORDER_ACCEPTED: "ORDER_ACCEPTED",
    ORDER_ASSIGNED: "ORDER_ASSIGNED",
    ORDER_REJECTED: "ORDER_REJECTED",
    ORDER_ON_PICKUP_LOCATION: "ORDER_ON_PICKUP_LOCATION",
    ORDER_ON_WAY: "ORDER_ON_WAY",
    ORDER_ON_DROP_LOCATION: "ORDER_ON_DROP_LOCATION",
    ORDER_DELIVERED: "ORDER_DELIVERED",
    ORDER_LOCATION_UPDATE: "COMPANY_LOCATION_UPDATE",
    ORDER_DATA: "ORDER_DATA",
    COMPANY_DRIVER_ADD: "COMPANY_DRIVER_ADD",
    COMPANY_DRIVER_REMOVE: "COMPANY_DRIVER_REMOVE",
  },
  API_ERROR_OBJ: {
    404: "API error",
    500: "Server Error",
    502: "Bad Gateway",
    503: "Service Unavailable",
    400: "Bad Request",
    401: "Unauthorized",
    403: "Forbidden",
  },
  USER_TYPES: {
    CUSTOMER: "CUSTOMER",
    MANUFACTURE: "MANUFACTURER",
    BOTH: "BOTH",
  },
  PRIORITY_TEXT: {
    HIGH: "Hot Lead",
    MEDIUM: "Warm Lead",
    LOW: "Cold Lead",
  },
  PRIORITY: {
    HIGH: "HIGH",
    MEDIUM: "MEDIUM",
    LOW: "LOW",
  },
  CONCERN_STATUS_TEXT: {
    TRANSACTION_FAILURE: "Transaction Failure",
    ORDER_DISPUTE: "Order Dispute",
    ACCOUNT_RELATED_ISSUE: "Account Related Issue",
    PARTNER_REQUEST: "Partner Request",
    MEDIA_QUERY: "Media Query",
    GENERAL_SUPPORT: "General Support",
    CAREER_OPPORTUNITY: "Career Opportunity",
    OTHER: "Other",
  },
  SUPPORT_STATUS: {
    PENDING: "PENDING",
    RESOLVED: "RESOLVED",
  },
  SUPPORT_STATUS_TEXT: {
    PENDING: "Pending",
    RESOLVED: "Resolved",
  },
  QUOTE_STATUS: {
    PENDING: "PENDING",
    ON_GOING: "ON_GOING",
    CONVERTED: "CONVERTED",
    JUNK: "JUNK",
    COMPLETED: "COMPLETED",
  },
  QUOTE_STATUS_TEXT: {
    PENDING: "Pending",
    ON_GOING: "On Going",
    CONVERTED: "Converted",
    JUNK: "Junk",
    COMPLETED: "Completed",
  },
  QUOTE_STATUS_COLOR: {
    PENDING: "pending",
    ON_GOING: "on_going",
    CONVERTED: "converted",
    JUNK: "junk",
    COMPLETED: "completed",
  },
  INDUSTRY_STATUS_TEXT: {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
    PENDING: "COMING SOON",
  },
  PROFILE_TYPE: {
    BUSINESS: "BUSINESS",
    INDIVIDUAL: "INDIVIDUAL",
    NOT_PREFER: "NOT_PREFER",
    FEMALE: "FEMALE",
    MALE: "MALE",
    CARETAKER: "OTHER",
    PATIENT: "SELF"
  },
  DOCTOR_STATUS: {
    PENDING: "PENDING",
    UNDER_REVIEW: "UNDER_REVIEW",
    REJECTED: "INACTIVE",
    ACTIVE: "ACTIVE",
    SUSPENDED: "SUSPENDED",
  },
  PIPELINE_STAGES: {
    QUALIFIED: "Qualified",
    CONTACT_MADE: "Contact Made",
    DEMO_SCHEDULED: "Demo Scheduled",
    PROPOSAL_MADE: "Proposal Made",
    NEGOTIATIONS_STARTED: "Negotiations Started",
    PENDING: "PENDING",
    IN_PROGRESS: "IN_PROGRESS",
    PROPOSAL_SENT: "PROPOSAL_SENT",
    ARCHIVED: "ARCHIVED",
    CUSTOMER: "CUSTOMER",
    INTERESTED: "INTERESTED",
    NOT_INTERESTED: "NOT_INTERESTED",
    CONVERTED: "CONVERTED",
    ALL: " ",
  },
  /** Lead status (matches eapl-crm-backend Lead.constants.js STATUS) */
  LEAD_STATUS: {
    UNASSIGNED: "UNASSIGNED",
    NEW: "NEW",
    INTERESTED: "INTERESTED",
    SUSPECT: "SUSPECT",
    SALES_DONE: "SALES_DONE",
    COMPLETED: "COMPLETED",
    DROPPED: "DROPPED",
    CONNECTED: "CONNECTED",
    NOT_CONNECTED: "NOT_CONNECTED",
    CONTACT_IN_FUTURE: "CONTACT_IN_FUTURE",
  },
  /** B2B lead business — multi-select (matches backend LeadBusiness) */
  BUSINESS_SEGMENTS: ["CES", "SOLAR", "LMEMS"],
  /** PowerOne app/admin — hidden from main Leads source filter; use PowerOne Leads screen */
  POWERONE_LEAD_SOURCES: ["POWERONE_APP", "POWERONE_ADMIN"],
  /** Lead source (matches eapl-crm-backend Lead.constants.js SOURCE) */
  LEAD_SOURCE: {
    WEBFORM: "WEBFORM",
    WEBSITE: "WEBSITE",
    WHATSAPP: "WHATSAPP",
    IVR: "IVR",
    INSTAGRAM: "INSTAGRAM",
    CRM: "CRM",
    FACEBOOK: "FACEBOOK",
    WEBHOOK: "WEBHOOK",
    SOCIAL_MEDIA: "SOCIAL_MEDIA",
    POWERONE_APP: "POWERONE_APP",
    POWERONE_ADMIN: "POWERONE_ADMIN",
  },
  /** Record type (matches eapl-crm-backend Lead.constants.js RECORD_TYPE) */
  RECORD_TYPE: {
    B2C: "B2C",
    B2B_DEALER: "B2B_DEALER",
    B2B_DISTRIBUTOR: "B2B_DISTRIBUTOR",
    HR: "HR",
    FINANCES: "FINANCES",
  },
  /** Display labels for record type (for dropdowns) */
  RECORD_TYPE_LABELS: {
    B2C: "B2C",
    B2B_DEALER: "B2B-DEALER",
    B2B_DISTRIBUTOR: "B2B-DISTRIBUTOR",
    HR: "HR",
    FINANCES: "FINANCES",
  },
  /** Display labels for lead source (for dropdowns) */
  LEAD_SOURCE_LABELS: {
    WEBFORM: "Webform",
    WEBSITE: "Website",
    WHATSAPP: "WhatsApp",
    IVR: "IVR",
    INSTAGRAM: "Instagram",
    CRM: "CRM",
    FACEBOOK: "Facebook",
    WEBHOOK: "Webhook",
    SOCIAL_MEDIA: "Social media",
    POWERONE_APP: "PowerOne app",
    POWERONE_ADMIN: "PowerOne admin",
  },
  /** Display labels for lead status (list/kanban/detail) */
  LEAD_STATUS_LABELS: {
    UNASSIGNED: "Unassigned",
    NEW: "New",
    INTERESTED: "Interested",
    SUSPECT: "Suspect",
    SALES_DONE: "Sales Done",
    COMPLETED: "Completed",
    DROPPED: "Dropped",
    CONNECTED: "Connected",
    NOT_CONNECTED: "Not connected",
    CONTACT_IN_FUTURE: "Contact in future",
  },
  SSE_ADMIN_NEW_LEAD_EVENTS_ENABLED,
  SSE_ADMIN_LEAD_STATUS_UPDATE_ENABLED,
  MODULES: {
    DASHBOARD: "DASHBOARD",
    LEADS: "LEADS",
    PROFILE: "PROFILE",
    SERVICES: "SERVICES",
    CONTACTS: "CONTACTS",
    CUSTOMER: "CUSTOMER",
    APPOINTMENTS: "APPOINTMENTS",
    WHATS_APP_CHAT: "WHATS_APP_CHAT",
    STAFF_LIST: "STAFF_LIST",
    SHIFTS: "SHIFTS",
    USER_ROLE: "USER_ROLE",
    CALENDAR: "CALENDAR",
    HEALTH_MARKERS: "HEALTH_MARKERS",
    ORDER_LIST: "ORDER_LIST",
    DOCTOR_REQUEST: "DOCTOR_REQUEST",
    REPORTS: "REPORTS",
    HCP: "HCP",
    DOCTORS: "DOCTORS",
    ROLES: "ROLES",
    GEOFENCES: "GEOFENCES",
    APP_ORDERS: "APP_ORDERS",
    FEEDBACK: "FEEDBACK",
    DEMAND_SUPPLY: "DEMAND_SUPPLY",
    EMPLOYEE: "EMPLOYEE",
    KNOWLEDGE_BASE: "KNOWLEDGE_BASE",
    EZUPP_BLOGS: "EZUPP_BLOGS",
    MAILER: "MAILER",
    POWERONE_IMPORT: "POWERONE_IMPORT",
    POWERONE_LEADS: "POWERONE_LEADS",
    /** Platinum dealer rewards lookup (header dialog; backend proxy). */
    PLATINUM_DEALER_REWARDS: "PLATINUM_DEALER_REWARDS",
  },

  LOG_ENABLED: true,
  WARNING_ENABLED: true,
  ERROR_ENABLED: true,

  /** Softphone iframe (go2market) - mob_no will come from profile later */
  SOFTPHONE_BASE_URL: "https://softphone.go2market.in/webrtc/dist/dist5/index.html",
  SOFTPHONE_OWNER_ID: "17372",
  SOFTPHONE_MOB_NO: "09319141142",
};

/**
 * When true, `SSE_EVENT` is not dispatched for this payload (admin lead stream only).
 * Other SSE events (appointments, transactions, etc.) are unaffected.
 */
export function shouldSuppressAdminLeadSseEvent(payload) {
  const event = payload?.event;
  if (!event) return false;
  if (
    !SSE_ADMIN_NEW_LEAD_EVENTS_ENABLED
    && (event === "NEW_LEAD_CREATED" || event === "NEW_LEAD_ASSIGNED")
  ) {
    return true;
  }
  if (!SSE_ADMIN_LEAD_STATUS_UPDATE_ENABLED && event === "LEAD_STATUS_UPDATE") {
    return true;
  }
  return false;
}

export const DR_MOREPEN_API_CREDENTIALS = {
    USERNAME: "prodmorepenhome",
    PASSWORD: "3c06bf544d5c7cbe77b60921",
};
